import axios from 'axios';

// NOTE: All backend routes are under /api/v1, so we set baseURL to unify all endpoints
const API_BASE_URL = '/api/v1';

export const api = axios.create({
  baseURL: API_BASE_URL,  // All API calls will be prefixed with /api/v1
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true, // Include HTTP-only cookies
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Allow certain requests to handle 401 locally (e.g., fallbacks)
      const url: string | undefined = error?.config?.url;
      const NO_REDIRECT_PATTERNS: string[] = [
        '/contracts/analyze-contract',
      ];
      if (
        url &&
        NO_REDIRECT_PATTERNS.some((p) => url === p || url.endsWith(p) || url.includes(p))
      ) {
        // Do not redirect; let caller's catch handle fallback
        return Promise.reject(error);
      }
      // Friendly handling: open auth on dashboard instead of alert/redirect to /login
      try {
        const onDashboard = window.location.pathname.startsWith('/dashboard');
        const intended = encodeURIComponent(window.location.pathname + window.location.search);

        if (onDashboard) {
          // If already on dashboard, emit event to open auth modal
          window.dispatchEvent(new CustomEvent('open-auth-modal', { detail: { mode: 'login', intendedPath: intended } }));
        } else {
          // Redirect to dashboard with query flag so it can open the modal on load
          const url = `/dashboard?requireRegistration=1&intendedPath=${intended}`;
          window.location.assign(url);
        }
      } catch (_) {
        // Silently ignore and fall back to no-op
      }
    }
    return Promise.reject(error);
  }
);
